export enum AbsenceMotives {
    unspecified,
    holidays,
    medical,
    APs
  }


// WEBPACK FOOTER //
// ./src/models/absence-motives.ts